"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findLinkEntities = void 0;
const findLinkEntities = (contentBlock, callback, contentState) => {
    contentBlock.findEntityRanges((character) => {
        const entityKey = character.getEntity();
        return entityKey !== null && contentState.getEntity(entityKey).getType() === "LINK";
    }, callback);
};
exports.findLinkEntities = findLinkEntities;
//# sourceMappingURL=utils.js.map